<template>
    <div
        class="p-6 bg-slate-300/30 rounded-2xl shadow-inner border-solid border-b border-t-0 border-x-0 border-white gap-3 flex flex-col"
    >
        <div class="flex justify-between items-center">
            <vx-button
                class="md:hidden outline-blue-600"
                data-test="toggle-filters"
                @click="showFilters = !showFilters"
                color="muted-dark"
                size="sm"
            >
                <font-awesome-icon widthAuto :icon="showFilters ? faCaretUp : faCaretDown"></font-awesome-icon>
                {{ showFilters ? 'Hide' : 'Show' }} Filters
            </vx-button>
            <span class="hidden md:inline font-bold text-base"> Filters </span>
            <vx-button
                class="outline-blue-600"
                @click="emit('reset')"
                data-test="reset-all"
                color="transparent"
                size="xs"
                type="button"
            >
                Reset All
                <font-awesome-icon class="text-[10px] ml-1" widthAuto :icon="faUndo"></font-awesome-icon>
            </vx-button>
        </div>

        <div v-if="showFilters" class="gap-4 flex flex-col sm:grid sm:grid-cols-12 md:flex md:flex-col">
            <slot />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { VxButton } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { ref } from 'vue';
import { faCaretDown, faCaretUp, faUndo } from '@fortawesome/pro-solid-svg-icons';

const showFilters = ref(true);

const emit = defineEmits(['reset']);
</script>
